import React from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "semantic-ui-react";
import { yup } from "utils";

import Form from "components/Form";

export function RedtailForm({ disabled, loading, onSubmit }) {
  const redtailFormSchema = yup.object({
    username: yup.string().required("Username is required"),
    password: yup.string().required("Password is required"),
  });

  const formProps = useForm({
    resolver: yupResolver(redtailFormSchema),
    defaultValues: { username: "", password: "" },
    mode: "onSubmit",
    criteriaMode: "all",
  });

  return (
    <Form id="redtail-form" {...formProps} onSubmit={onSubmit}>
      <Form.Input
        name="username"
        label="Redtail's Username"
        fluid
        placeholder="Enter your redtail username"
      />
      <Form.Input
        name="password"
        label="Redtail's Password"
        type="password"
        fluid
        placeholder="Enter your redtail password"
      />
      <Button
        primary
        fluid
        loading={loading}
        disabled={loading || disabled}
        style={{ marginTop: "20px" }}
      >
        Connect with Redtail
      </Button>
    </Form>
  );
}

RedtailForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

RedtailForm.defaultProps = {
  loading: false,
  disabled: false,
};

export default RedtailForm;
